export const MAX_MESSAGE_ATTACHMENT_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB

export const ACCEPTED_MESSAGE_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/heic',
  'image/tiff',
  'video/quicktime',
  'video/mp4',
  'video/x-m4v',
  'video/x-ms-wmv',
  'video/webm',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'audio/mpeg',
  'audio/wav',
  'audio/x-wav',
  'audio/mp4',
  'audio/x-m4a',
];

export const ACCEPTED_MESSAGE_FILE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'heic',
  'tiff',
  'tif',
  'mov',
  'mp4',
  'm4v',
  'wmv',
  'webm',
  'pdf',
  'docx',
  'xlsx',
  'pptx',
  'mp3',
  'wav',
  'm4a',
];
